import * as types from './mutation-types';

export const getTaskflowData = ({commit}) => {
    const response = {
        tasks: [
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2017',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: true,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: false
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2017',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: false
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2017',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: true,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: false
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: true
            },{
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: true
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: true,
                overdue: true
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: true,
                overdue: true
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: false,
                outstanding: true,
                today: false,
                upcomingThisWeek: false,
                overdue: false
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: true,
                outstanding: true,
                today: true,
                upcomingThisWeek: false,
                overdue: false
            },
            {
                id: '123',
                category: 'Maintenance',
                task: 'Inventory Chemical Closet',
                area: 'Zone 3',
                date: '12/12/2016',
                estAllocatedTime: '30 Min',
                assignedTo: 'Joe Blogs',
                notes: 'notes',
                completed: true,
                outstanding: true,
                today: true,
                upcomingThisWeek: false,
                overdue: false
            }
        ]
    }
    commit(types.GET_TASKFLOW_DATA, response.tasks);
}